// @ts-check
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons/faFileDownload';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faCalendarAlt as farCalendarAlt } from '@fortawesome/free-regular-svg-icons/faCalendarAlt';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons/faPlayCircle';
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faUserMd } from '@fortawesome/free-solid-svg-icons/faUserMd';

/**
 * Warning: side-effects!
 * See: https://github.com/FortAwesome/react-fontawesome/tree/9ee4f58cfc07296f250b870249a66ed493f8589f#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
 * Building this "library" allows us to only import the SVG icons we care to use,
 * imported individually above, and then use them by string reference in components.
 * This function needs to be run in an initializing module of the app/site.
 */
export default function createIconLibrary() {
  library.add(
    faArrowRight,
    faBullhorn,
    faChevronDown,
    faChartBar,
    faFileDownload,
    faTimes,
    faCalendarAlt,
    farCalendarAlt,
    faLock,
    faCopy,
    faQuestion,
    faFileAlt,
    faPlayCircle,
    faTags,
    faPlus,
    faUserMd
  );
}
